import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid } from "@material-ui/core";
import { ErrorLoginPageForm } from "./ErrorLoginPageForm";
import PersonalizedLoginForm from "./PersonalizedLoginForm";
import { LocaleSwitcher } from "./LocaleSwitcher";
import LoginHeader from "./LoginHeader";
import { TextoEntrar } from "./TextoEntrar";

const useStyles = makeStyles(() => ({
  login: {
    paddingLeft: "18%",
    '@media (max-width: 600px)' : {
      paddingLeft: "10%",
    }
  },
  localeBar: {
    fontFamily: "Proxima-Nova,sans-serif",
    color: "#FFF",
    fontSize: 18,
    position: "relative",
  },
  localeGrid: {
    width: "100%",
    fontSize: "13px",
    height: "auto",
    lineHeight: 2,
  },
  divPosRight: {
    marginLeft: "auto",
    marginRight: "20%",
  },
}));

export function LoginPageForm() {
  const classes = useStyles();

  return (
    <Card square>
      <Grid container className={clsx(classes.localeBar, "localeBar")}>
        <Grid container className={classes.localeGrid}>
          <Grid className={classes.divPosRight}>
            <LocaleSwitcher />
          </Grid>
        </Grid>
      </Grid>
      <LoginHeader />
      <Grid>
        <Grid container className={clsx(classes.login, "login")}>
          <TextoEntrar />
            <Grid container>
              <PersonalizedLoginForm />
          </Grid>
        </Grid>
        <Grid>
          <ErrorLoginPageForm />
        </Grid>
      </Grid>
    </Card>
  );
}
